
import { Table, Stack, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Divider, Grid, Typography, Tooltip, IconButton, Autocomplete, TextField, InputAdornment, useTheme, Button, Toolbar, } from "@mui/material";

import { styled } from '@mui/material/styles';
import { useState, useEffect } from "react";
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import Header from "../../../Layout/Header";
import { callApi } from "../../../utils/apiClient";

import { AddCircleOutline } from '@mui/icons-material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import Cancel from '@mui/icons-material/CancelOutlined';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";

import customParseFormat from "dayjs/plugin/customParseFormat";
import CallAlertBar from "../../../Layout/Alertbar";
import useDepartment from "../../../hooks/useDepartment";
import useEmployeeByDepartmentID from "../../../hooks/useEmployeeByDepartment";
import useMaterialList from "../../../hooks/useMaterialList";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import useRequestIndentNumber from "../../../hooks/useRequestIndentNumber";
import useApprovedByEmployee from "../../../hooks/useApprovedbyEmployee";
import useRequestIndentCRUD from "../../../hooks/useRequestIndentCRUD";
import RequestIndentActionMenu from "./RequestIndentSubMenu";
import useRequestIndentNumberListByDepartment from "../../../hooks/useRequestIndentNumberByDepartmentID";
import ApproveIndentActionMenu from "./ApproveIndentSubMenu";
import AddNewIssue from "../../stores/issues/AddIssueIndent";
import AmentApproveRequest from "../../../Layout/Ament-Approve-Request";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import { tokens } from "../../../theme/theme";



const AddNewRequestIndent = ({ handlecallback, editRequestIndentID, setEditRequestIndentID, selectedMode, setSelectedMode, requestData, budgetID, formMode, materialData, tableMode }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // Parent Roll  Alert Values
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Indent Creation! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const callError = (serverityval, msg, title) => {
        // Update state with error message        
        setParentRollSeverityvalue(serverityval);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(title);
        setParentRollMsgOpen(true);
    };

    dayjs.extend(customParseFormat);


    const [selectedButtonName, setSelectedButtonName] = useState('');
    const [selectionMode, setSelectionMode] = useState(0);
    const [updateStatus, setUpdateStatus] = useState(false);

    const { department, selectedDepartment, selectedDepartmentID, setSelectedDepartment, setSelectedDepartmentID, loadDepartmentByID } = useDepartment(editRequestIndentID);
    const { employee, selectedEmployee, selectedEmployeeID, setSelectedEmployee, setSelectedEmployeeID, loadEmployeeByID } = useEmployeeByDepartmentID();
    const { materialList, setMaterialList, selectMaterial, selectMaterialID, loadMaterialListByID, } = useMaterialList();
    const { requestIndentNumber, setRequestIndentNumber, generateRequestIndentNumberByDepartment } = useRequestIndentNumber(editRequestIndentID);
    const { approvedBy, selectedApprovedBy, selectedApprovedByID, setSelectedApprovedBy, setSelectedApprovedByID, loadApprovedByID } = useApprovedByEmployee();
    const { requestIndentNumberList, selectedRequestIndentNumberList, selectedRequestIndentNumberListID, setSelectedRequestIndentNumberList, setSelectedRequestIndentNumberListID, loadIndentNumbersByDepartmentID } = useRequestIndentNumberListByDepartment(editRequestIndentID);

    const statusOptions = ['Created', 'Pending', 'Approved'];
    const [requestStatus, setRequestStatus] = useState('Created');
    const { processIndent } = useRequestIndentCRUD(callError);

    //pop-up
    const [openChildRollList, setOpenChildRollList] = useState(false);


    // update selection mode 
    useEffect(() => {
        if (!updateStatus) {
            setSelectionMode(selectedMode);
        }
    }, [selectedMode, setSelectedMode])


    const callback = () => {
        handlecallback();
    }

    useEffect(() => {
        const fetchEmployees = async () => {
            if (editRequestIndentID === 0) {
                if (selectedDepartmentID && selectedDepartmentID !== 0) {
                    await loadEmployeeByID(selectedEmployeeID, selectedDepartmentID);
                }
            }
        };

        fetchEmployees();
    }, [selectedDepartmentID, selectedEmployeeID]); // Added selectedEmployeeID to the dependency array

    useEffect(() => {
        const fetchApprovedBy = async () => {
            if (selectedDepartmentID && selectedDepartmentID !== 0) {
                await loadApprovedByID(selectedApprovedByID, selectedDepartmentID);
            }
        };

        fetchApprovedBy();
    }, [selectedDepartmentID, selectedApprovedByID]); // Added selectedApprovedByID to the dependency array


    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: colors.blueAccent[500],
            color: 'white',
            fontSize: '14px',
            borderRadius: '10px',
            padding: '10px',

        },
        [`& .MuiTooltip-arrow`]: {
            color: colors.blueAccent[500],
        },
    });

    const [reason, setReason] = useState('');
    const [requestDate, setRequestDate] = useState(dayjs());
    const [approvedDate, setApprovedDate] = useState(dayjs());
    const [disableSave, setDisableSave] = useState(false);
    // List of Parameter
    const [isLoadEditPO, setLoadEditPO] = useState(false);
    const [rows, setRows] = useState([{ id: 1, material: '', id_material: 0, material_name: null, uom: null, uomId: 0, quantity_requested: 1, scheduled_issue_date: new Date().toISOString().split('T')[0], quantity_approved: 0, purpose: '' }]);


    // direct purchase request
    const [directData, setDirectData] = useState(false);
    useEffect(() => {

        if (selectedMode === 53 && directData === false) {
            setRows(requestData);
            setDirectData(true);
        }

    }, [selectedMode])


    useEffect(() => {
        const fetchData = async () => {
            if (!isLoadEditPO && editRequestIndentID != 0) {
                try {

                    const para = {
                        p_company_id: localStorage.getItem("companyid"),
                        p_plant_id: 1,
                        p_id_request: editRequestIndentID,
                    };

                    const purchaseOrderResponse = await callApi(API_ENDPOINTS.REQUEST_INDENT_GET_DETAIL_BY_ID, 'POST', { 'Content-Type': 'application/json' }, para);
                    const purchaseOrder = purchaseOrderResponse[0];

                    const productPara = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1, };
                    const [productsData] = await Promise.all([
                        callApi(API_ENDPOINTS.MATERIAL_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, productPara),
                    ]);

                    if (productsData && productsData.length > 0) setMaterialList(productsData);

                    if (purchaseOrder) {
                        setRequestIndentNumber(purchaseOrder.request_indent_number);
                        setReason(purchaseOrder.reason);
                        //setRequestDate(purchaseOrder?.request_date ? dayjs(purchaseOrder.request_date) : null);
                        // setRequestDate(
                        //     purchaseOrder?.request_date
                        //         ? dayjs(purchaseOrder.request_date, 'DD-MM-YYYY HH:mm:ss')
                        //         : null
                        // );
                        //  setApprovedDate(
                        //     purchaseOrder?.approved_date
                        //         ? dayjs(purchaseOrder.approved_date, 'DD-MM-YYYY HH:mm:ss')
                        //         : null
                        // );
                        
                        setRequestDate(dayjs(purchaseOrder.request_date));
                        setApprovedDate(dayjs(purchaseOrder.approved_date));


                        setRequestStatus(purchaseOrder.status);

                        const productData = typeof purchaseOrder.requstitem_details === 'string'
                            ? JSON.parse(purchaseOrder.requstitem_details)
                            : purchaseOrder.requstitem_details;

                        if (Array.isArray(productData)) {
                            const mappedRows = productData.map(item => ({
                                ...item,
                                material: productsData.find(p => p.id_material === item.id_material) || '',
                                id_material: item.id_material,
                                material_name: productsData.find(p => p.id_material === item.id_material)?.material_name || '',
                                uom: productsData.find(p => p.id_material === item.id_material)?.unit_of_measurement || '',
                                uomId: productsData.find(p => p.id_material === item.id_material)?.id_uom || '',
                                quantity_approved: item.quantity_approved ? item.quantity_approved : item.quantity_requested, // added for testing thiravidam

                            }));

                            setRows(mappedRows);
                        } else {
                            setRows([]);
                        }

                        await loadDepartmentByID(purchaseOrder.id_department);
                        await loadIndentNumbersByDepartmentID(purchaseOrder.id_department, 'all', editRequestIndentID);
                        await loadEmployeeByID(purchaseOrder.id_requester, purchaseOrder.id_department);
                        await loadApprovedByID(purchaseOrder.approved_by, purchaseOrder.id_department);
                    }
                } catch (error) {
                    callError('error', error.message, 'Error');
                }
            }
        };

        fetchData();
    }, [isLoadEditPO, editRequestIndentID]);



    const fetchRquestData = async (request_id) => {
        if (request_id != 0) {
            try {

                const para = {
                    p_company_id: localStorage.getItem("companyid"),
                    p_plant_id: 1,
                    p_id_request: request_id,
                };

                const purchaseOrderResponse = await callApi(API_ENDPOINTS.REQUEST_INDENT_GET_DETAIL_BY_ID, 'POST', { 'Content-Type': 'application/json' }, para);
                const purchaseOrder = purchaseOrderResponse[0];

                const productPara = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1, };
                const [productsData] = await Promise.all([
                    callApi(API_ENDPOINTS.MATERIAL_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, productPara),
                ]);


                if (productsData && productsData.length > 0) setMaterialList(productsData);

                if (purchaseOrder) {
                    setRequestIndentNumber(purchaseOrder.request_indent_number);
                    setReason(purchaseOrder.reason);

                    // setRequestDate(
                    //     purchaseOrder?.request_date
                    //         ? dayjs(purchaseOrder.request_date, 'DD-MM-YYYY HH:mm:ss')
                    //         : null
                    // );
                     setRequestDate(dayjs(purchaseOrder.request_date));

                    setRequestStatus(purchaseOrder.status);
                    const productData = typeof purchaseOrder.requstitem_details === 'string'
                        ? JSON.parse(purchaseOrder.requstitem_details)
                        : purchaseOrder.requstitem_details;

                    if (Array.isArray(productData)) {
                        const mappedRows = productData.map(item => ({
                            ...item,
                            material: productsData.find(p => p.id_material === item.id_material) || '',
                            id_material: item.id_material,
                            material_name: productsData.find(p => p.id_material === item.id_material)?.material_name || '',
                            uom: productsData.find(p => p.id_material === item.id_material)?.unit_of_measurement || '',
                            uomId: productsData.find(p => p.id_material === item.id_material)?.id_uom || '',
                            // purpose: productsData.find(p => p.id_material === item.id_material)?.purpose || '',
                            quantity_approved: item.quantity_requested,
                        }));

                        setRows(mappedRows);
                    } else {
                        setRows([]);
                    }

                    await loadDepartmentByID(purchaseOrder.id_department);
                    await setSelectedEmployeeID(purchaseOrder.id_requester);
                }
            } catch (error) {
                callError('error', error.message, 'Error');
            }
        }
    };


    const handleAddRow = () => {
        const newRowId = rows.length + 1;
        const newRow = { id: newRowId, material: '', id_material: 0, material_name: null, uom: null, uomId: 0, quantity_requested: 1, scheduled_issue_date: new Date().toISOString().split('T')[0], quantity_approved: 0, purpose: '' };
        setRows([...rows, newRow]);
    };


    const removeRow = (index) => {
        const updatedRows = [...rows];
        updatedRows.splice(index, 1); // Remove the row at the specified index
        setRows(updatedRows);
    };


    const handleProductChange = (index, product) => {
        const newRows = [...rows];
        newRows[index].material = product;
        newRows[index].id_material = product.id_material || '';
        newRows[index].material_name = product.material_name || '';
        newRows[index].uom = product.unit_of_measurement || '';
        newRows[index].uomId = product.id_uom || '';
        setRows(newRows);

    };

    const handleQuantityChange = (index, quantity) => {
        const newRows = [...rows];
        newRows[index].quantity_requested = quantity;
        setRows(newRows);

    };
    const handleApprovedQuantityChange = (index, value) => {
        setRows((prevRows) =>
            prevRows.map((row, i) =>
                i === index ? { ...row, quantity_approved: value } : row
            )
        );
    };
    const handlepurpose = (index, value) => {
        setRows((prevRows) =>
            prevRows.map((row, i) =>
                i === index ? { ...row, purpose: value } : row
            )
        );
    };

    const handleDateChange = (index, date) => {
        const newRows = [...rows];
        newRows[index].scheduled_issue_date = date ? date.format('YYYY-MM-DD') : '';  // Format date correctly
        setRows(newRows);
    };


    const handleSaveAndDraft = () => {

        if (!selectedDepartmentID || selectedDepartmentID === 0) {
            callError('warning', 'Department is required', 'Validation');
            return;
        }
        if (!requestDate || requestDate === null) {
            callError('warning', 'Request Date is required', 'Validation');
            return;
        }

        if (!selectedEmployeeID || selectedEmployeeID === 0) {
            callError('warning', 'Requester is required', 'Validation');
            return;
        }
        if (rows.length === 0 || rows[0].id_material === 0) {
            callError('warning', 'At least one item is required in the request indent', 'Validation');
            return;
        }

        if (selectionMode === 1) {
            if (!approvedDate || approvedDate === null) {
                callError('warning', 'Approved Date is required', 'Validation');
                return;
            }
            if (!selectedApprovedByID || selectedApprovedByID === 0) {
                callError('warning', 'Approved By is required', 'Validation');
                return;
            }

            const hasZeroQty = rows.some(row => Number(row.quantity_approved) === 0);

            if (hasZeroQty) {
                callError(
                    'warning',
                    'Approved quantity must be greater than 0 for all items',
                    'Validation'
                );
                return;
            }

        }



        const modifiedRows = rows.map(({ material, uom, ...rest }) => rest);
        let mode_id = 0;
        let id_request = 0;

        if (editRequestIndentID != 0) {
            mode_id = 1;
        }

        if (selectionMode === 0) {
            id_request = editRequestIndentID !== 0 ? editRequestIndentID : 0;
        }
        else {
            id_request = selectedRequestIndentNumberListID;
        }

        const requestBody = {
            p_company_id: localStorage.getItem('companyid'),
            p_plant_id: 1,
            p_id_request: id_request,
            p_mode: mode_id,
            p_id_requester: selectedEmployeeID,
            p_id_department: selectedDepartmentID,
            p_request_indent_number: requestIndentNumber,
            p_reason: reason,
            p_request_date: dayjs(requestDate).format('YYYY-MM-DD hh:mm:ss'),
            p_status: requestStatus,
            p_requestitem_list: modifiedRows,
            p_approved_date: dayjs(approvedDate).format('YYYY-MM-DD hh:mm:ss'),
            p_approved_by: selectedApprovedByID,
            p_id_budget: budgetID,
        }
        processIndent(selectionMode, editRequestIndentID, requestBody);
        //disable save button 
        setDisableSave(true);
    };

    const handlecallProcess = (buttonName) => {
        if (buttonName === 'Approve request') {
            setSelectionMode(1);
            setEditRequestIndentID(0)
            setUpdateStatus(false);
            setLoadEditPO(false);
            setApprovedDate(dayjs());
        }
        else if (buttonName === 'Ament') {
            setOpenChildRollList(true);
        }
    };

    const handlecallApprovedProcess = (buttonName) => {
        if (buttonName === 'Approve request') {
            setSelectionMode(5);
            setUpdateStatus(false);
            setLoadEditPO(false);
        }
    };

    const callbackIssue = () => {
        setSelectionMode(1);
        setUpdateStatus(false);
        setLoadEditPO(false);
    }

    const closeChildRollList = () => {
        setOpenChildRollList(false);
    };

    useEffect(() => {
        if (Array.isArray(materialData) && materialData.length > 0) {

            setDirectData(true);

            const mappedRows = materialData.map((item, index) => ({
                id: index + 1,
                material: materialList.find(p => p.id_material === item.id_material) || '',
                id_material: item.id_material,
                material_name: materialList.find(p => p.id_material === item.id_material)?.material_name || '',
                uom: materialList.find(p => p.id_material === item.id_material)?.uom || item.uom,
                uomId: materialList.find(p => p.id_material === item.id_material)?.id_uom || '',
                quantity_requested: item.quantity_requested,
                scheduled_issue_date: new Date().toISOString().split('T')[0],
                quantity_approved: 0,
                purpose: 'For Direct Purchase from the Store',
            }));
            setRows(mappedRows);
        }
    }, [materialData, materialList]);



    return (<>

        {selectionMode === 5 ? (<>
            <AddNewIssue handlecallback={callbackIssue} editIssueIndentID={0} selectedMode={0} SelectedDepartmentID={selectedDepartmentID} SelectedRequestID={editRequestIndentID} />
        </>) : (<>
            <Box padding={0}>
                {(selectionMode === 0 || selectionMode === 53) ? (
                    <Header
                        title={editRequestIndentID === 0 ? 'New Indent' : 'Edit Indent'}
                        subtitle=""
                        callback={callback}
                    />
                    // title={editRequestIndentID === 0 ? 'New Request Indent' : 'Edit Request Indent'}
                ) : (
                    <Header
                        title={editRequestIndentID === 0 ? 'Approve Indent' : 'Edit Approve Indent'}
                        subtitle=""
                        callback={callback}
                    />
                    //  title={editRequestIndentID === 0 ? 'Approve Request Indent' : 'Edit Approve Request Indent'}
                )}
                <Divider />
                {editRequestIndentID > 0 && (
                    <>
                        {(selectionMode === 0 || selectionMode === 53) ? (
                            <>
                                <RequestIndentActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} tableMode={tableMode} />
                                <Divider />
                            </>
                        ) : <>
                            <ApproveIndentActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallApprovedProcess} formMode={formMode} />
                            <Divider />
                        </>
                        }
                    </>
                )}
                <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                    setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                    setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        px: 1,
                        py: 1
                    }}
                >
                    <Typography variant="h6"  >
                        <span style={{ color: 'red' }}>*</span> Mandatory fields
                    </Typography>
                </Box>

                <AmentApproveRequest open={openChildRollList} handleBackWinderMachineEntry={closeChildRollList} onClose={closeChildRollList} documentNumber={requestIndentNumber} documentID={editRequestIndentID} departmentID={selectedDepartmentID} requesterID={selectedEmployeeID} module={(selectionMode === 0 || selectionMode === 53) ? "Request Indent" : "Approve Indent"} mode={0} requestID={0} approverID={0} reason={''} />

                <Box
                    sx={{
                        padding: "5px",
                        borderRadius: "10px",
                        maxHeight: {
                            xs: '72vh', // Extra small devices (phones)
                            sm: '72vh', // Small devices (tablets)
                            md: '74vh', // Medium devices (small laptops)
                            lg: '74vh', // Large devices (desktops)
                            xl: '82vh', // Extra large devices (large desktops)
                        },
                        overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                        '&::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: colors.primary[400],
                            borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: colors.blueAccent[600],
                            borderRadius: '10px',
                            '&:hover': {
                                background: colors.blueAccent[800],
                            },
                        },
                        '&::-webkit-scrollbar-corner': {
                            background: colors.primary[700],
                        }
                    }}>

                    <Grid container>


                        {editRequestIndentID > 0 && (
                            <>
                                {(selectionMode === 0 || selectionMode === 53) ? (<>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ backgroundColor: colors.primary[400] }}  >
                                        <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >
                                            <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Indent Number
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                                <TextField value={requestIndentNumber} fullWidth size="small" label="" required variant="outlined"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="start">
                                                                <CustomTooltip
                                                                    title={
                                                                        <span>
                                                                            <b>click here to enable or disable auto generation of purchase order number.</b> <br />
                                                                        </span>}
                                                                >
                                                                    <SettingsIcon style={{ fontSize: "20px" }} />
                                                                </CustomTooltip>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </>) : (null)}
                            </>
                        )}


                        <Grid item xs={12} xl={12} >
                            <Grid container padding="0px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                                <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Department <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={department}
                                        value={selectedDepartment}
                                        disabled={editRequestIndentID !== 0}
                                        onChange={(event, newValue) => {
                                            setSelectedDepartment(newValue);
                                            setSelectedDepartmentID(newValue.id);
                                            // loadIndentNumbersByDepartmentID(newValue.id, selectionMode === 0 ? 'request indent' : 'approve indent');
                                            loadIndentNumbersByDepartmentID(newValue.id, selectionMode === 0 ? 'request indent' : 'request indent');
                                            if (newValue) {
                                                generateRequestIndentNumberByDepartment(newValue.id, newValue.description);
                                            } else {
                                                setRequestIndentNumber("");
                                            }

                                        }}
                                        getOptionLabel={(option) => option.description || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>

                            </Grid>
                        </Grid>

                        {(selectionMode == 0 || selectionMode === 53) ? (<>

                            {editRequestIndentID === 0 && (<>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}   >
                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >
                                        <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center">
                                            <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                Indent Number <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                            <TextField value={requestIndentNumber} fullWidth size="small" label="" required variant="outlined"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="start">
                                                            <CustomTooltip
                                                                title={
                                                                    <span>
                                                                        <b>click here to enable or disable auto generation of purchase order number.</b> <br />
                                                                    </span>}
                                                            >
                                                                <SettingsIcon style={{ fontSize: "20px" }} />
                                                            </CustomTooltip>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>)}
                        </>) : (null)}

                        {selectionMode === 1 ? (<>
                            <Grid item xs={12} xl={12} >
                                <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                                    <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center">
                                        <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                            Indent Number <span style={{ color: 'red' }}>*</span>
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>

                                        <Autocomplete
                                            size="small"
                                            fullWidth
                                            options={requestIndentNumberList}
                                            value={selectedRequestIndentNumberList}
                                            onChange={(event, newValue) => {
                                                setSelectedRequestIndentNumberList(newValue);
                                                setSelectedRequestIndentNumberListID(newValue.id_request);
                                                fetchRquestData(newValue.id_request);
                                            }}
                                            getOptionLabel={(option) => option.request_indent_number || ''}
                                            renderInput={(params) => (
                                                <TextField {...params} label="" required variant="outlined" />
                                            )}
                                        />
                                    </Grid>


                                </Grid>
                            </Grid>
                        </>) : (null)}
                        <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                                <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Indent Date <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Stack spacing={2}>
                                            <DatePicker
                                                size="small"
                                              
                                                // format="DD-MMM-YYYY"

                                                value={dayjs(requestDate)}
                                                disabled={editRequestIndentID !== 0}
                                                onChange={(date) => setRequestDate(date)}
                                                slotProps={{ textField: { size: 'small' }, field: { format: 'DD-MMM-YYYY' } }}
                                                fullWidth
                                                // className="customDatePicker"
                                                renderInput={(props) => (
                                                    <TextField required {...props} />
                                                )}
                                            />
                                        </Stack>
                                    </LocalizationProvider>
                                </Grid>

                                <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Indentor <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={employee}
                                        value={selectedEmployee}
                                        disabled={editRequestIndentID !== 0}
                                        onChange={(event, newValue) => {
                                            setSelectedEmployee(newValue);
                                            setSelectedEmployeeID(newValue ? newValue.id_employee : null);
                                        }}
                                        getOptionLabel={(option) => option.employee_name || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                              

                            </Grid>
                        </Grid> */}

                        {selectionMode === 1 ? (
                            <>
                                <Grid item xs={12} xl={12} >
                                    <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                                        <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center" >
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                Approved Date <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <Stack spacing={2}>
                                                    <DatePicker
                                                        size="small"
                                                        id="Orderdate"
                                                        // format="DD-MMM-YYYY"
                                                        value={dayjs(approvedDate)}
                                                        onChange={(date) => setApprovedDate(date)}
                                                        slotProps={{ textField: { size: 'small' }, field: { format: 'DD-MMM-YYYY' } }}
                                                        fullWidth
                                                        // className="customDatePicker"
                                                        renderInput={(props) => (
                                                            <TextField required {...props} />
                                                        )}
                                                    />
                                                </Stack>
                                            </LocalizationProvider>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                Approved By <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                            <Autocomplete
                                                size="small"
                                                fullWidth
                                                options={approvedBy}
                                                value={selectedApprovedBy}


                                                onChange={(event, newValue) => {
                                                    setSelectedApprovedBy(newValue);
                                                    setSelectedApprovedByID(newValue ? newValue.id : null);
                                                }}

                                                getOptionLabel={(option) => option.name || ''}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="" required variant="outlined" />
                                                )}
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>

                                {/* <Grid item xs={12} xl={12} >
                                    <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                                      

                                    </Grid>
                                </Grid> */}
                            </>
                        ) : (null)}
                        <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                                <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Reasons
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                    <TextField value={reason} onChange={(e) => setReason(e.target.value)} fullWidth size="small" label="" required variant="outlined" />
                                </Grid>

                                <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Status
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                    <Autocomplete
                                        fullWidth
                                        options={statusOptions}
                                        disabled
                                        value={requestStatus}
                                        onChange={(event, newValue) => {
                                            setRequestStatus(newValue);
                                        }}
                                        renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>



                        <Grid item xs={12} xl={12} mt={5} >
                            <Divider />
                        </Grid>

                        <Grid item xs={12} lg={11} xl={10.5}  >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                                <Grid item xs={12} sm={11} md={12} lg={12} xl={12} display="flex-start" justifyContent="center" >
                                    <CustomTableContainer colors={colors}>
                                        <TableContainer>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Material</TableCell>
                                                        {/* <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Material Description</TableCell> */}
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', width: 100 }}>Quantity</TableCell>
                                                        {selectionMode === 1 && (
                                                            <TableCell style={{ fontSize: '14px', padding: 10, textAlign: 'center', width: 150 }}>
                                                                Approved Quantity
                                                            </TableCell>
                                                        )}
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', width: 80 }}>UOM</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', width: 200 }}>Date Of Requirement</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', width: 400 }}>Purpose</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {rows.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ size: "small", width: "300px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                <Autocomplete
                                                                    size="small"
                                                                    fullWidth
                                                                    disabled={!(selectionMode === 0 || selectionMode === 53)}
                                                                    placeholder="Type or click to select an material"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiSelect-select': {
                                                                            padding: '0px',
                                                                        },
                                                                        backgroundColor: 'transparent',
                                                                        padding: 0,
                                                                        '& .MuiInputBase-root': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiSvgIcon-root': {
                                                                            fontSize: '18px', // 👈 smaller icon size
                                                                        },
                                                                        '& .MuiInputBase-root': {
                                                                            paddingRight: '6px', // optional: reduce padding around icon
                                                                        },
                                                                    }}

                                                                    options={materialList}
                                                                    value={row.material}
                                                                    getOptionLabel={(option) => `${option.material_code || ''} - ${option.material_name || ''}`}
                                                                    onChange={(event, newValue) => handleProductChange(index, newValue)}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            size="small"
                                                                            placeholder="Type or click to select an material"
                                                                            fullWidth
                                                                            {...params}
                                                                            variant="outlined"
                                                                        />
                                                                    )}
                                                                />

                                                            </TableCell>


                                                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 10, textAlign: 'right' }}>
                                                                <TextField
                                                                    fullWidth
                                                                    disabled={!(selectionMode === 0 || selectionMode === 53)}
                                                                    size="small"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '8px',
                                                                            textAlign: 'right',
                                                                        },
                                                                    }}
                                                                    variant="outlined"
                                                                    type="number"
                                                                    value={row.quantity_requested}
                                                                    // onChange={(e) => handleQuantityChange(index, e.target.value)}
                                                                    inputProps={{ min: 0.1, step: 0.1 }} // allow decimals, set minimum to 0.1
                                                                    onChange={(e) => {
                                                                        const value = parseFloat(e.target.value);
                                                                        if (value >= 0.1) {
                                                                            handleQuantityChange(index, value);
                                                                        }
                                                                    }}
                                                                />
                                                            </TableCell>
                                                            {selectionMode === 1 && (
                                                                <TableCell style={{ border: '1px solid black', fontSize: '12px', padding: 10, textAlign: 'right' }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}
                                                                        variant="outlined"
                                                                        type="number"
                                                                        value={row.quantity_approved || '0'}
                                                                        onChange={(e) => {
                                                                            const approvedValue = parseFloat(e.target.value);
                                                                            const requestedValue = parseFloat(row.quantity_requested);

                                                                            if (approvedValue <= requestedValue) {
                                                                                handleApprovedQuantityChange(index, approvedValue);
                                                                            }
                                                                        }}

                                                                    />
                                                                </TableCell>
                                                            )}
                                                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                <TextField
                                                                    fullWidth
                                                                    disabled={!(selectionMode === 0 || selectionMode === 53)}
                                                                    size="small"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '8px',
                                                                            textAlign: 'center',
                                                                        },
                                                                    }}
                                                                    variant="outlined"
                                                                    type="text"
                                                                    value={row.uom}


                                                                />
                                                            </TableCell>
                                                            {/* //scheduled_issue_date */}
                                                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 10, textAlign: 'right' }}>
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <Stack spacing={2}>
                                                                        <DatePicker
                                                                            sx={{
                                                                                backgroundColor: 'transparent',
                                                                                padding: 0,
                                                                                '& .MuiInputBase-root': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiSvgIcon-root': {
                                                                                    fontSize: '18px', // 👈 smaller icon size
                                                                                },
                                                                                '& .MuiInputBase-root': {
                                                                                    paddingRight: '6px', // optional: reduce padding around icon
                                                                                },
                                                                            }}
                                                                            size="small"
                                                                            format="DD-MMM-YYYY"
                                                                            id="Orderdate"
                                                                            value={row.scheduled_issue_date ? dayjs(row.scheduled_issue_date) : null} // Convert to dayjs
                                                                            onChange={(date) => handleDateChange(index, date)} // Pass correct parameters
                                                                            slotProps={{
                                                                                textField: {
                                                                                    size: 'small', variant: 'standard', InputProps: {
                                                                                        disableUnderline: true, // Remove underline from 'standard' variant
                                                                                    },
                                                                                }
                                                                            }}
                                                                            fullWidth
                                                                            disabled={!(selectionMode === 0 || selectionMode === 53)}
                                                                            className="customDatePicker"
                                                                            renderInput={(props) => (
                                                                                <TextField
                                                                                    required {...props} />
                                                                            )}
                                                                        />
                                                                    </Stack>
                                                                </LocalizationProvider>
                                                            </TableCell>
                                                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '8px',
                                                                            textAlign: 'center',
                                                                        },
                                                                    }}
                                                                    variant="outlined"
                                                                    type="text"
                                                                    value={row.purpose}
                                                                    disabled={!(selectionMode === 0 || selectionMode === 53)}
                                                                    onChange={(e) => handlepurpose(index, e.target.value)}
                                                                />
                                                            </TableCell>


                                                            {(selectionMode === 0 || selectionMode === 53) && (
                                                                <TableCell
                                                                    sx={{
                                                                        border: "0px solid transparent",
                                                                        fontSize: "12px",
                                                                        padding: 0,
                                                                        width: 40,
                                                                    }}
                                                                >
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => removeRow(index)}
                                                                        color="secondary"
                                                                    >
                                                                        <HighlightOffOutlinedIcon
                                                                            sx={{ color: "#ef5350", fontSize: "16px" }}
                                                                        />
                                                                    </IconButton>
                                                                </TableCell>
                                                            )}

                                                        </TableRow>
                                                    ))}
                                                </TableBody>

                                            </Table>

                                            {(selectionMode === 0 || selectionMode === 53) ? (
                                                <Box mt={2}>
                                                    <Button
                                                        size="small"
                                                        variant="contained"
                                                        color="secondary"
                                                        sx={{ textTransform: "none" }}
                                                        startIcon={<AddCircleOutline />}
                                                        onClick={handleAddRow}
                                                    >
                                                        Add New Row
                                                    </Button>
                                                </Box>
                                            ) : (
                                                <></>
                                            )}



                                        </TableContainer>
                                    </CustomTableContainer>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} xl={12} mt={5} >
                            <Divider />
                        </Grid>
                    </Grid>
                </Box>


                {formMode === 0 && (<>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Box position="fixed" sx={{ top: 'auto', bottom: 0, backgroundColor: "transparent" }}>

                                <Toolbar>
                                    {(selectionMode === 0 || selectionMode === 53) ? (<>
                                        <Button size="small" variant="contained" color="secondary" onClick={handleSaveAndDraft} disabled={disableSave} startIcon={<SaveAltIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save Request</Button>
                                    </>) : (<>
                                        <Button size="small" variant="contained" color="secondary" onClick={handleSaveAndDraft} disabled={disableSave} startIcon={<SaveAltIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Approve Request</Button>
                                    </>)}
                                    <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} onClick={callback} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>
                                </Toolbar>
                            </Box>
                        </Grid>
                    </Grid>

                </>)}

            </Box>
        </>)}
    </>)
}
export default AddNewRequestIndent;